import { useQuery } from '@tanstack/react-query'
import { getAchievementsByUser } from '../services/achievementsService'
import type { UserAchievement } from '../models/UserAchievement'

// Get all achievements for a user
export const useAchievements = (userId: string) => {
  return useQuery<UserAchievement[]>({
    queryKey: ['achievements', userId],
    queryFn: () => getAchievementsByUser(userId),
    enabled: !!userId,
    staleTime: 1000 * 60 * 5,
  })
}